import React from 'react';
import { VIC, NSW, QLD, TAS, SA, WA, NT, ACT } from '@duke-hq/ui/components/StatesIcons/icons';

const states: Record<string, React.FC> = {
  VIC: VIC,
  NSW: NSW,
  QLD: QLD,
  TAS: TAS,
  SA: SA,
  WA: WA,
  NT: NT,
  ACT: ACT,
};

export interface StateIconProps {
  siteState: string;
}

export function StateIcon({ siteState }: StateIconProps): React.ReactElement {
  const Component = states[siteState];
  return Component ? <Component /> : <p>--</p>;
}
